import {mapGetters} from 'vuex';
import mvtInputGeo from '@/common/components/mvtinputgeo/mvt-inputgeo.vue';

export default {
    name: 'ownerContent',
    inject: ['$eventBus'],
    components: {
        mvtInputGeo
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        contentSectionImg1() {
            return this.glb.cdnUrl + 'vimages/homeowner-1.png';
        },
        contentSectionImg2() {
            return this.glb.cdnUrl + 'vimages/homeowner-2.png';
        },
        contentSectionImg3() {
            return this.glb.cdnUrl + 'vimages/homeowner-3.png';
        },
        contentSectionImg4() {
            return this.glb.cdnUrl + 'vimages/homeowner-4.png';
        }
    },
    data: function() {
        return {
            geoInfo: {
                text: '',
                geo: null
            }
        }
    },
    watch:{
        geoInfo(newVal){
            if(newVal){
                this.$eventBus.$emit('eventbus-claimed-home', newVal);
            }
        }
    },
}
